import { LoadingType, setLoadingState } from 'handlers';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

export const useLayoutLoading = (...isLoading: boolean[]) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setLoadingState({ type: LoadingType.ApplicationUpdating, loading: isLoading.some((item) => item) }));
  }, [...isLoading]);
};
